
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import {PatientLeistungStatistikOptions, PatientLeistungStatistikPayload} from '@/store/statistik';
    import { VMenu } from '@/types/Components';

    @Component({
        computed: {
            ...mapState('leistungen', ['leistungen']),
            ...mapState('leistungen', { loadersLeistungen: 'loaders' }),
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['exportPatientenMitLeistungenExcel']),
            ...mapActions('leistungen', ['loadLeistungen']),
        },
    })
    export default class Patientenmitleistungen extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public loadLeistungen!: () => void;
        public exportPatientenMitLeistungenExcel!: (payload: { options: PatientLeistungStatistikPayload }) => void;
        public zeitraumMenu = false;
        public zeitraumErrorMessages: string[] = [];

        public options: PatientLeistungStatistikOptions = {
            leistungen: [],
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
        };

        public alleLeistungen = false;
        public search = '';

        public get canExport(): boolean {
            const [vonZeitraum, bisZeitraum] = this.options.zeitraum;

            return this.zeitraumErrorMessages.length === 0 &&
                (this.alleLeistungen || this.options.leistungen?.length !== 0) &&
                !!vonZeitraum && !!bisZeitraum;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadLeistungen();
                this.zeitraumErrorMessages = [];
                this.alleLeistungen = false;
                this.options.leistungen = [];
            }
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);

            this.zeitraumErrorMessages = [];

            const [von, bis] = this.options.zeitraum;
            if (Math.abs(moment(von).diff(moment(bis), 'days')) > 365) {
                this.zeitraumErrorMessages.push('Zeitraum darf nicht mehr als 365 Tage überschreiten.');
            }
        }

        public onClickExport(): void {
            const options: PatientLeistungStatistikOptions = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            if (this.alleLeistungen) {
                delete options.leistungen;
            }

            this.exportPatientenMitLeistungenExcel({ options });
        }
    }
